<template>
  <div class="points-mall">
    <section class="pc-container points-summary">
      <div>
        <p>现有积分</p>
        <strong v-if="isLoggedIn">{{ pointsBalance }}</strong>
        <a v-else class="login-link" @click="goLogin('/pc/points')">请登录后查看</a>
      </div>
      <div class="summary-links">
        <a @click="goMember('/pc/member/coupons')">我的优惠券 <img :src="icons.right" alt=""></a>
        <a @click="goMember('/pc/member/points/exchanges')">兑换记录 <img :src="icons.right" alt=""></a>
        <a @click="goMember('/pc/member/points/details')">积分明细 <img :src="icons.right" alt=""></a>
        <a @click="goMember('/pc/member/points/rules')">积分兑换规则 <img :src="icons.right" alt=""></a>
      </div>
      <div class="coin-mark">积分</div>
    </section>

    <section class="pc-container points-filter-bar">
      <div class="filter-row">
        <span class="filter-label">类目：</span>
        <div class="filter-options">
          <button v-for="item in categories" :key="item" :class="{ active: activeCategory === item }" @click="activeCategory = item">{{ item }}</button>
        </div>
      </div>
      <div class="filter-row">
        <span class="filter-label">积分区间：</span>
        <div class="filter-options">
          <button v-for="item in pointRanges" :key="item" :class="{ active: activeRange === item }" @click="activeRange = item">{{ item }}</button>
        </div>
      </div>
    </section>

    <section class="pc-container gift-grid">
      <div v-if="loading" class="empty">加载中...</div>
      <div v-else-if="!visibleGifts.length" class="empty">暂无可兑换优惠券</div>
      <article v-for="item in visibleGifts" :key="item.id" class="gift-card">
        <div class="gift-image" @click="openDetail(item)">
          <div class="coupon-face"><strong>¥ {{ couponAmount(item.discountAmount) }}</strong><span>满{{ couponAmount(item.thresholdAmount) }}元可用</span></div>
        </div>
        <h2 @click="openDetail(item)">{{ productTitle(item) }}</h2>
        <p class="gift-meta">{{ couponValidity(item) }}</p>
        <p v-if="item.limitText" class="limit">{{ item.limitText }}</p>
        <div class="points"><b>{{ item.pointsPrice }}</b>积分</div>
        <button @click="openDetail(item)">立即兑换</button>
      </article>
    </section>

    <div v-if="detailVisible" class="modal-mask" @click.self="closeDetail">
      <div class="gift-modal">
        <div class="modal-title">
          优惠券详情
          <button @click="closeDetail"><img :src="icons.close" alt=""></button>
        </div>
        <div class="modal-body">
          <button class="slide left"><img :src="icons.left" alt=""></button>
          <div class="detail-image">
            <div class="coupon-face"><strong>¥ {{ couponAmount(selectedGift.discountAmount) }}</strong><span>满{{ couponAmount(selectedGift.thresholdAmount) }}元可用</span></div>
          </div>
          <button class="slide right"><img :src="icons.right" alt=""></button>
          <h3>{{ productTitle(selectedGift) }}</h3>
          <div class="detail-points"><b>{{ selectedGift.pointsPrice }}</b> 积分</div>
          <div class="detail-intro">
            <strong>使用规则</strong>
            <p>满{{ couponAmount(selectedGift.thresholdAmount) }}元可用，优惠{{ couponAmount(selectedGift.discountAmount) }}元</p>
            <p>{{ couponValidity(selectedGift) }}</p>
            <p>{{ selectedGift.description }}</p>
          </div>
          <button class="exchange-now" :disabled="submitting" @click="handleExchange">
            {{ submitting ? '兑换中...' : '立即兑换' }}
          </button>
        </div>
      </div>
    </div>

    <div class="wish-order">心愿单</div>
  </div>
</template>

<script>
  import { message } from 'ant-design-vue'
  import { createPcPointsExchange, getPcMemberProfile, getPcPointsGiftDetail, getPcPointsGiftList, getPcMemberAddresses } from '@/api/pc'
  import commerce from '@/utils/pcCommerce'
  import { productTitle, productType, productBrand } from '@/utils/pcProductDisplay'

  const pcIcons = {
    right: require('@/assets/icons/pc/chevron-right.svg'),
    left: require('@/assets/icons/pc/chevron-left.svg'),
    close: require('@/assets/icons/pc/close.svg')
  }

  export default {
    name: 'PcPointsMall',
    data() {
      return {
        loading: false,
        gifts: [],
        activeCategory: '不限',
        activeRange: '不限',
        pointsBalance: 0,
        detailVisible: false,
        selectedGift: {},
        submitting: false,
        defaultAddress: null,
        icons: pcIcons,
        pointRanges: ['不限', '0-5万', '5万-10万', '10万-20万', '20万以上']
      }
    },
    computed: {
      isLoggedIn() {
        return typeof localStorage !== 'undefined' && Boolean(localStorage.getItem('mall_access_token'))
      },
      categories() {
        return ['不限', ...new Set(this.gifts.map(item => item.category).filter(Boolean))]
      },
      visibleGifts() {
        return commerce.filterPointsGifts(this.gifts, {
          category: this.activeCategory,
          range: this.activeRange
        })
      }
    },
    created() {
      this.loadGifts()
      if (this.isLoggedIn) this.loadDefaultAddress()
      if (this.isLoggedIn) this.loadPoints()
    },
    methods: {
      productTitle,
      productType,
      productBrand,
      couponAmount(value) { return commerce.formatMoney(Number(value || 0), 2) },
      couponValidity(item) {
        const relative = Number(item.validDays) > 0 ? `兑换后${item.validDays}天内有效` : ''
        const end = item.couponEndTime ? `最迟${String(item.couponEndTime).replace('T', ' ')}到期` : ''
        return [relative, end].filter(Boolean).join('，') || '长期有效'
      },
      normalizeGift(item) {
        return {
          ...commerce.normalizePointsGift(item),
          category: item.giftCategory || item.category || '',
          giftCategory: item.giftCategory || item.category || '',
          productType: item.productType || item.giftCategory || item.category || ''
        }
      },
      loadPoints() {
        getPcMemberProfile().then(data => {
          this.pointsBalance = Number((data && data.points) || 0)
        }).catch(() => {})
      },
      loadGifts() {
        this.loading = true
        getPcPointsGiftList({ page: 1, pageSize: 50 }).then(data => {
          const records = Array.isArray(data) ? data : (data && data.records ? data.records : [])
          this.gifts = records.filter(item => item.couponId).map(this.normalizeGift)
        }).catch(() => {
          this.gifts = []
        }).finally(() => {
          this.loading = false
        })
      },
      loadDefaultAddress() {
        getPcMemberAddresses().then(rows => { this.defaultAddress = (rows || []).find(item => item.isDefault === 1) || (rows || [])[0] || null }).catch(() => {})
      },
      goLogin(redirect) {
        this.$router.push({ path: '/pc/login', query: { redirect } }).catch(() => {})
      },
      goMember(path) {
        if (!this.isLoggedIn) {
          this.goLogin(path)
          return
        }
        this.$router.push(path).catch(() => {})
      },
      openDetail(item) {
        this.selectedGift = item
        this.detailVisible = true
        getPcPointsGiftDetail(item.id).then(data => {
          this.selectedGift = this.normalizeGift({
            ...item,
            ...(data || {})
          })
        }).catch(() => {
          this.selectedGift = item
        })
      },
      closeDetail() {
        this.detailVisible = false
      },
      handleExchange() {
        if (this.submitting) return
        if (!this.isLoggedIn) {
          this.closeDetail()
          this.goLogin('/pc/points')
          return
        }
        if (this.selectedGift.giftCategory === '实物' && !this.defaultAddress) {
          message.warning('请先在会员中心维护收货地址')
          this.goMember('/pc/member/addresses')
          return
        }
        this.submitting = true
        const address = this.defaultAddress || {}
        createPcPointsExchange({
          giftId: this.selectedGift.id,
          customerName: address.receiverName || '默认客户',
          receiverName: address.receiverName || '',
          receiverPhone: address.receiverPhone || '',
          receiverAddress: address.region ? `${address.region} ${address.detailAddress}` : ''
        }).then(() => {
          message.success('兑换成功，优惠券已到账')
          this.loadPoints()
          this.loadGifts()
          this.closeDetail()
        }).catch(err => {
          message.error(err.message || '兑换失败，请登录后重试')
        }).finally(() => {
          this.submitting = false
        })
      }
    }
  }
</script>

<style scoped>
  .points-mall {
    min-height: calc(100vh - 206px);
    padding-bottom: 70px;
    background: #f0f0f0;
  }
  .coupon-face { display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 12px; padding: 18px; color: #008bea; background: #fff7e8; width: 100%; border-radius: 8px; }
  .coupon-face strong { font-size: 30px; }

  .points-summary {
    position: relative;
    height: 126px;
    margin-top: 16px;
    padding: 34px 50px;
    border-radius: 8px 8px 0 0;
    background: linear-gradient(110deg, #fff7e8, #fff0d3);
    box-shadow: 0 4px 12px rgba(148, 101, 36, .15);
    overflow: hidden;
  }

  .points-summary p {
    margin: 0 0 12px;
    font-size: 14px;
  }

  .points-summary strong {
    color: #0f172a;
  }

  .login-link {
    color: #008bea;
    font-weight: 700;
    cursor: pointer;
  }

  .summary-links {
    position: absolute;
    top: 60px;
    right: 138px;
    display: flex;
    gap: 42px;
    color: #008bea;
    font-size: 13px;
  }

  .summary-links a {
    display: inline-flex;
    align-items: center;
    gap: 4px;
  }

  .summary-links img {
    width: 12px;
    height: 12px;
  }

  .coin-mark {
    position: absolute;
    right: 38px;
    top: 16px;
    width: 92px;
    height: 92px;
    border-radius: 50%;
    background: #ffd98b;
    color: rgba(255, 255, 255, .72);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 32px;
    font-weight: 800;
    transform: rotate(-28deg);
  }

  .points-filter-bar {
    margin-top: 20px;
    padding: 0 20px;
    background: #fff;
  }

  .filter-row {
    min-height: 48px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #eef1f5;
  }

  .filter-row:last-child {
    border-bottom: 0;
  }

  .filter-label {
    flex: 0 0 76px;
    color: #64748b;
  }

  .filter-options {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px 18px;
  }

  .filter-row button {
    min-width: 62px;
    height: 34px;
    border: 0;
    background: #fff;
    color: #333;
    cursor: pointer;
  }

  .filter-row .active {
    border: 1px solid #008bea;
    color: #008bea;
    position: relative;
  }

  .filter-row .active:after {
    content: "";
    position: absolute;
    right: 0;
    bottom: 0;
    border-width: 8px;
    border-style: solid;
    border-color: transparent #1684ff #1684ff transparent;
  }

  .gift-grid {
    margin-top: 18px;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 10px;
  }

  .gift-card {
    min-height: 284px;
    padding: 12px 12px 16px;
    background: #fff;
    text-align: center;
  }

  .gift-image {
    height: 150px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .gift-image img {
    width: 150px;
    height: 150px;
    object-fit: contain;
  }

  .gift-card h2 {
    height: 42px;
    margin: 12px 0 0;
    color: #555;
    font-size: 14px;
    line-height: 21px;
    font-weight: 400;
    overflow: hidden;
    cursor: pointer;
  }

  .limit {
    height: 18px;
    margin: 0;
    color: #008bea;
    font-size: 13px;
  }

  .gift-meta { margin: 4px 0; color: #667085; font-size: 12px; overflow-wrap: anywhere; }

  .points {
    margin-top: 8px;
    color: #555;
  }

  .points b {
    color: #008bea;
    font-size: 18px;
    margin-right: 2px;
  }

  .gift-card button,
  .exchange-now {
    width: 100px;
    height: 28px;
    margin-top: 9px;
    border: 1px solid #008bea;
    border-radius: 15px;
    background: #fff;
    color: #008bea;
    cursor: pointer;
  }

  .empty {
    grid-column: 1 / -1;
    padding: 90px 0;
    text-align: center;
    color: #64748b;
    background: #fff;
  }

  .modal-mask {
    position: fixed;
    z-index: 90;
    inset: 0;
    background: rgba(0, 0, 0, .42);
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding-top: 176px;
  }

  .gift-modal {
    width: 400px;
    background: #fff;
    border: 1px solid #0097df;
  }

  .modal-title {
    height: 40px;
    padding-left: 14px;
    background: #0799db;
    color: #fff;
    font-weight: 700;
    line-height: 40px;
  }

  .modal-title button {
    float: right;
    width: 40px;
    height: 40px;
    border: 0;
    background: transparent;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .modal-title button img {
    width: 18px;
    height: 18px;
    filter: brightness(0) invert(1);
  }

  .modal-body {
    position: relative;
    padding: 14px 14px 26px;
  }

  .detail-image {
    height: 282px;
    border: 1px solid #ddd;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .detail-image img {
    width: 280px;
    height: 280px;
    object-fit: contain;
  }

  .slide {
    position: absolute;
    top: 136px;
    width: 30px;
    height: 46px;
    border: 0;
    background: #eee;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .slide img {
    width: 22px;
    height: 22px;
  }

  .slide.left {
    left: 14px;
  }

  .slide.right {
    right: 14px;
  }

  .modal-body h3 {
    margin: 14px 0 8px;
    color: #555;
    font-size: 14px;
    font-weight: 400;
  }

  .detail-points b {
    color: #008bea;
    font-size: 24px;
  }

  .detail-intro {
    margin-top: 12px;
    color: #555;
    line-height: 20px;
  }

  .detail-intro p {
    margin: 2px 0;
  }

  .exchange-now {
    display: block;
    margin: 18px auto 0;
  }

  .exchange-now:disabled {
    opacity: .6;
    cursor: not-allowed;
  }

  .wish-order {
    position: fixed;
    right: 210px;
    bottom: 38px;
    width: 80px;
    height: 80px;
    border-radius: 8px;
    background: #fff;
    color: #1684ff;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 8px 18px rgba(15, 23, 42, .08);
  }
</style>

